import { render, staticRenderFns } from "./SertifikasiDokumen.vue?vue&type=template&id=d119cdd2&"
import script from "./SertifikasiDokumen.vue?vue&type=script&lang=js&"
export * from "./SertifikasiDokumen.vue?vue&type=script&lang=js&"
import style0 from "./SertifikasiDokumen.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports